import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../../providers/Auth";
import { useHistory } from "react-router-dom";

import { TextField, Button, CircularProgress } from "@mui/material";

import { Container, Form, FormContainer } from "./styles";
import api from "../../services/api";

const signInSchema = yup.object().shape({
  name: yup.string().required("Character name obrigatório"),
});

interface SignInData {
  name: string;
  spriteId: string;
}

const CreateChar = () => {
  const [loading, setLoading] = useState(false);
  const [spriteId, setSpriteId] = useState("");
  const [sprites, setSprites] = useState<any[]>([]);
  const { createChar, accessToken, user } = useAuth();

  const history = useHistory();

  if (user.char) {
    history.push("/dashboard");
  }

  useEffect(() => {
    api
      .get("/sprites", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setSprites(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignInData>({ resolver: yupResolver(signInSchema) });

  const handleSignIn = (data: SignInData) => {
    setLoading(true);
    createChar(data.name, spriteId)
      .then((_) => {
        toast.success("Login efetuado com sucesso!");
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Email ou senha inválidos");
        setLoading(false);
      });
  };

  return (
    <Container className="rpgui-content">
      <FormContainer className="rpgui-container framed-golden status">
        <Form onSubmit={handleSubmit(handleSignIn)}>
          <h1>Create Character</h1>
          <TextField
            fullWidth
            autoComplete="email"
            label={!!errors.name ? errors.name.message : "Character Name"}
            variant="outlined"
            {...register("name")}
            error={!!errors.name}
          />

          <div className="rpgui-container framed-golden-2 sprite">
            <h3>Select your hero</h3>
            <ul>
              {sprites.map((sprite: any) => (
                <li>
                  {/* <button onClick={() => console.log("Clicou")}> */}
                  <img
                    src={sprite.url}
                    alt={sprite.name}
                    className={
                      sprite.id === spriteId
                        ? "selected"
                        : "naofosteselecionadootario"
                    }
                    onClick={() => setSpriteId(sprite.id)}
                  />
                  {/* </button> */}
                </li>
              ))}
            </ul>
          </div>

          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            type="submit"
            className="rpgui-button"
          >
            {loading ? <CircularProgress /> : "Create"}
          </Button>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default CreateChar;
